import ApiService from '@/services/core/api.service'

const AdminDistributionService = {
  async get (query) {
    return ApiService.get(`admin/distributions?${query}`)
  }
}

export default AdminDistributionService
